import { CSSObject } from 'styled-components';
import { ReactNode } from 'react';
import  Control  from '../../../controls/control';
import { ControlButtonProps } from '../../../controls/components';

export interface DrawerActionButtonProps extends ControlButtonProps {
    text?: string | undefined;
    display_type?: "text-only" | "image-only" | "image-before-text" | "image-after-text" | undefined;
    button_class?: string | undefined;
    image?: string | undefined;
    image_style?: CSSObject | undefined;
}

function formatButton(props: DrawerActionButtonProps): ReactNode {
    if (props.display_type === "image-only" || props.text === undefined) {
        return (
            <i className={props.image} style={props.image_style}></i>
        )
    }

    if (props.display_type === "image-before-text") {
        return (
            <span>
                <i className={props.image + " me-3"} style={props.image_style}></i>
                {props.text}
            </span>
        )
    }

    if (props.display_type === "image-after-text") {
        return (
            <span>
                {props.text}
                <i className={props.image + " ms-3"} style={props.image_style}></i>
            </span>
        )
    }

    return (
        <span> {props.text} </span>
    )
}

export const DrawerTemplateButton: React.FC<DrawerActionButtonProps> = (props) => {
    const buttonClass = "btn " + (props.button_class ?? "" );
    return (
        < Control.Button {...props}  className={buttonClass}>
            {formatButton(props)}
        </Control.Button>
    );
};